"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactNotifications = require("react-notifications");
// TODO: implement: if callback + missing time => sticky
//const STICKY_TIME = 10000;
var _default = _reactNotifications.NotificationManager;
exports["default"] = _default;